<template>
  <div class="card mb-3">
    <div class="card-body">
      <div
        v-if="!note.editing"
        class="position-relative"
      >
        <div class="media mb-2 align-items-center">
          <div class="media-left">
            <span class="profile-img small mr-3" :style="`background-image: url(${note.user.image});`"></span>
          </div>
          <div class="media-body">
            <div class="small font-weight-bold">
              {{ note.user.display_name }}
            </div>
            <div
              class="small"
              :title="createdAt"
            >
              {{ when }}
            </div>
          </div>
        </div>
        <div
          v-if="note.content"
          v-html="note.content"
          class="content"
        ></div>
        <div
          v-else
          class="content text-muted"
        >
          No Content
        </div>
        <div
          class="actions"
        >
          <button
            class="btn btn-sm btn-white mr-1"
            @click.prevent="edit()"
          >
            <i class="fa fa-fw fa-pencil"></i>
          </button>
          <button
            class="btn btn-sm btn-white"
            @click.prevent="deleteNote()"
          >
            <i class="fa fa-fw fa-trash"></i>
          </button>
        </div>
      </div>
      <div
        v-else
      >
        <inline-editor
          name="content"
          v-model="edited.content"
          placeholder="Type your note here"
        ></inline-editor>
        <hr>
        <button
          class="btn btn-primary btn-sm"
          @click.prevent="updateNote()"
        >
          Save Note
        </button>
        <button
          class="btn btn-link btn-sm text-body"
          @click.prevent="cancelEdit()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.content {
  :last-child {
    padding-bottom: 0;
    margin-bottom: 0;
  }
}

.actions {
  position: absolute;
  top: -5px;
  right: -5px;
  display: none;
}

.card:hover {
  .actions {
    display: block;
  }
}
</style>

<script>
import { diffForHumans, formatDate } from '@/lib/moment'
import { updateNote, deleteNote } from '@/api'
import InlineEditor from '@/components/InlineEditor'
import alertify from 'alertify.js'

export default {
  components: {
    InlineEditor
  },
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      edited: {
        id: null,
        content: null
      }
    }
  },
  computed: {
    when () {
      return diffForHumans(this.note.created_at)
    },
    createdAt () {
      return formatDate(this.note.created_at, 'MMMM d, YYYY h:mm a')
    }
  },
  methods: {
    edit () {
      this.edited = Object.assign({}, this.note)
      this.note.editing = true
    },
    cancelEdit () {
      this.note.editing = false
    },
    async updateNote () {
      this.note.content = this.edited.content
      let response = await updateNote(this.note)
      this.note.editing = false
    },
    deleteNote () {
      alertify.confirm('Are you sure you want to delete this note?', () => {
        deleteNote(this.note)
        this.$emit('deleted')
      })
    }
  }
}
</script>